import { legacy_createStore as createStore, compose, applyMiddleware } from 'redux';
import rootReducer from '@/state/rootReducer';
import { ThunkMiddleware, thunk } from 'redux-thunk';
import { IState } from '@/state/IState';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
type Actions = any;

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk as ThunkMiddleware<IState, Actions>)));

export function getStore() {
    return store;
}
